"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberField = void 0;
const EditorFieldBase_1 = require("./EditorFieldBase");
class NumberField extends EditorFieldBase_1.EditorFieldBase {
}
exports.NumberField = NumberField;
